import React__default from 'react';
import { Link, Box } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../DefaultIcon/index.js';

var FolderLink = function (_a) {
    var title = _a.title, onClick = _a.onClick, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b, className = _a.className, children = _a.children;
    if (onClick) {
        return (React__default.createElement(Link, { component: "button", className: clsx("FolderLink", className), onClick: onClick, title: title, underline: "hover", sx: {
                display: "flex",
                alignItems: "center"
            } },
            React__default.createElement(KIcon, { fontSize: "small", sx: {
                    paddingRight: "5px"
                }, className: "fa-solid fa-images" }),
            children));
    }
    else {
        return (React__default.createElement(Box, { className: clsx("FolderLink", className), title: title, sx: {
                display: "flex",
                alignItems: "center"
            } },
            React__default.createElement(KIcon, { fontSize: "small", sx: {
                    paddingRight: "5px"
                }, className: "fa-solid fa-images" }),
            children));
    }
};

export { FolderLink as default };
//# sourceMappingURL=index.js.map
